import { Component, forwardRef, Inject, Input, OnInit, ViewContainerRef } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TEMPLATE_CONTENT } from '../../common/endpoints';
import { TemplateLoaderService } from '../../dashboard-area/template-loader/template-loader.service';
import { HttpService } from '../../service/http.service';
import { UiService } from '../../service/ui.service';
import { AbstractThingContextService } from '../../shared/class/abstract-thing-context-service.class';

@Component({
    selector: 'include-template',
    template: ''
})
export class IncludeTemplateComponent implements OnInit {

    @Input() name: string;

    constructor(
        @Inject(forwardRef(() => TemplateLoaderService)) private templateLoaderService: TemplateLoaderService,
        @Inject(forwardRef(() => ViewContainerRef)) private vcRef: ViewContainerRef,
        @Inject(forwardRef(() => AbstractThingContextService)) private thingContextService: AbstractThingContextService,
        @Inject(forwardRef(() => UiService)) private uiService: UiService,
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    ngOnInit() {
        let thing = this.thingContextService.getCurrentThing();
        this.uiService.getUserPagedTemplates(this.name, 0, 1, thing ? thing.thingDefinitionId : null).then(templates => {
            if (templates.content.length > 0) {
                const template = templates.content[0];
                firstValueFrom(this.httpService.getText(TEMPLATE_CONTENT.replace('{id}', template.id))).then(content => {
                    this.templateLoaderService.loadFromText(content, this.vcRef, true, thing);
                });
            } else {
                this.templateLoaderService.loadFromText('', this.vcRef, true, thing);
            }
        }).catch(() => this.templateLoaderService.loadFromText(TemplateLoaderService.TEMPLATE_ERROR, this.vcRef, true));
    }
}